// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"pageLoader_pageLoader__nChMU","spinner":"pageLoader_spinner__ICcQP"};